import ReviewCarouselComponent from 'components/reviewCarousel';
import React from 'react';
import { BlockComponentProps } from 'strapi/types/utils';

export const ReviewCarousel = ({
  block,
}: BlockComponentProps<'marketing-website.review-carousel'>) => {
  return <ReviewCarouselComponent reviewContent={block.items ?? []} />;
};
